const dataDesserts = [

    {
  
      id: 1,
  
      price: 25,
  
      img: 'cake1',
  
      name: 'Strawberry dream',
  
      category: 'CAKES'
  
  },
  
  {
  
    id: 2,
  
    price: 50,
  
    img: 'cake2',
  
    name: ' FUNtastic cake ',
  
    category: 'CAKES'
  
  },
  
  {
  
    id: 3,
  
    price: 30,
  
    img: 'cake3',
  
    name: 'Classic brownie',
  
    category: 'CAKES'
  
  },
  
  {
  
      id: 4,
  
      price: 40,
  
      img: 'cake4',
  
      name: 'Banana splash',
  
      category: 'CAKES'
  
  },
  
  {
  
    id: 5,
  
    price: 25,
  
    img: 'cake5',
  
    name: 'Cinnamon cake',
  
    category: 'CAKES'
  
  },
  
  {
  
    id: 6,
  
    price: 20,
  
    img: 'cake6',
  
    name: 'Be my cherry',
  
    category: 'CAKES'
  
  },
  
  {
  
    id: 7,
  
    price: 25,
  
    img: 'muffin1',
  
    name: 'Chocolate muffins',
  
    category: 'MUFFINS'
  
  },
  
  {
  
    id: 8,
  
    price: 20,
  
    img: 'muffin2',
  
    name: 'Cream muffins',
  
    category: 'MUFFINS'
  
  },
  
  {
  
    id: 9,
  
    price: 20,
  
    img: 'cookies1',
  
    name: 'Hearts with chocolate',
  
    category: 'COOKIES'
  
  },
  
  {
  
    id: 10,
  
    price: 15,
  
    img: 'cookies2',
  
    name: 'Crunchy fanstasy',
  
    category: 'COOKIES'
  
  },
  
  {
  
    id: 11,
  
    price: 15,
  
    img: 'cookies3',
  
    name: 'Berlin cookies',
  
    category: 'COOKIES'
  
  },
  
  {
  
    id: 12,
  
    price: 10,
  
    img: 'crepes1',
  
    name: 'Crepes fantasy',
  
    category: 'CREPES'
  },
  
    {
    
      id: 13,
    
      price: 13,
    
      img: 'crepes2',
    
      name: 'Crepes with fruits',
    
      category: 'CREPES'
    
    },
  
    {
    
      id: 14,
    
      price: 25,
    
      img: 'crepes3',
    
      name: 'Loving crepes',
    
      category: 'CREPES'
    
    }
  
  ] 
  
  export default dataDesserts;